import script from "./ButtonCloseModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonCloseModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});qInstall(script, 'directives', {ClosePopup});
